import React from 'react'
import LazyLoad from 'react-lazyload'
import { Link } from 'react-router-dom'
import { SwiperCarousel } from '../../../components'
import images from '../../../database/partner-logos.json'
import styles from './logo-marque.module.css'

const LogoSlider = () => (
  <div className="mobile-fullwidth">
    <div className="relative mb-12 lg:mb-20">
      <div className={`z-10 absolute left-0 top-0 h-full w-24 lg:w-48 ${styles['gradient-left']}`}></div>
      <SwiperCarousel autoplay={{
        delay: 2000,
        disableOnInteraction: false
      }} loop={true} pagination={false}>
        {
          images.map((d, i) => (
            <div className="w-full flex items-center" key={i}>
              <Link to="/organization/1/detail" className="mx-auto block">
                <LazyLoad height={60}>
                  <img className="mx-auto block" alt="logo" src={d} style={{maxHeight: '60px'/* , filter: 'grayscale(100%)' */}}/>
                </LazyLoad>
              </Link>
            </div>
          ))
        }
      </SwiperCarousel>
      <div className={`z-10 absolute right-0 top-0 h-full w-24 lg:w-48 ${styles['gradient-right']}`}></div>
    </div>
  </div>
)

export { LogoSlider }
